import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface PermissionTemplatesState {
  searchText: string;
  selectedUserIds: number[];
  selectedGroupIds: number[];
  selectedRoleIds: string[];
  pagination: {
    itemsPerPage: number;
    currentPage: number;
  };
}

const initialState: PermissionTemplatesState = {
  searchText: '',
  selectedUserIds: [],
  selectedGroupIds: [],
  selectedRoleIds: [],
  pagination: {
    itemsPerPage: 10,
    currentPage: 1,
  },
};

const permissionTemplatesSlice = createSlice({
  name: 'permissionTemplates',
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
      state.pagination.currentPage = 1;
    },
    setSelectedUsers: (state, action: PayloadAction<number[]>) => {
      state.selectedUserIds = action.payload;
    },
    setSelectedGroups: (state, action: PayloadAction<number[]>) => {
      state.selectedGroupIds = action.payload;
    },
    setSelectedRoles: (state, action: PayloadAction<string[]>) => {
      state.selectedRoleIds = action.payload;
    },
    resetApplyTemplate: (state) => {
      state.selectedUserIds = [];
      state.selectedGroupIds = [];
      state.selectedRoleIds = [];
    },
    setPermissionTemplatesPagination: (
      state,
      action: PayloadAction<Partial<PermissionTemplatesState['pagination']>>,
    ) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
  },
});

export const {
  setSearchText,
  setSelectedUsers,
  setSelectedGroups,
  resetApplyTemplate,
  setSelectedRoles,
  setPermissionTemplatesPagination,
} = permissionTemplatesSlice.actions;

export default permissionTemplatesSlice.reducer;
